import { render, staticRenderFns } from "./writeIssueModal.vue?vue&type=template&id=194eeb1e&scoped=true&"
import script from "./writeIssueModal.vue?vue&type=script&lang=ts&"
export * from "./writeIssueModal.vue?vue&type=script&lang=ts&"
import style0 from "./writeIssueModal.vue?vue&type=style&index=0&id=194eeb1e&lang=scss&scoped=true&"
import style1 from "./writeIssueModal.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "194eeb1e",
  null
  
)

export default component.exports